import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stu-heads',
  templateUrl: './stu-heads.component.html',
  styleUrls: ['./stu-heads.component.css']
})
export class StuHeadsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
